import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./system-names.actions";
import * as fromGraphql from "./system-names.graphql";
import {map, switchMap} from "rxjs";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {GET_ALL_INSTITUTION_NAMES} from "./system-names.graphql";
import {loadSystemNamess} from "./system-names.actions";


@Injectable()
export class SystemNamesEffects {
  createSystemNames$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionSystemNamess),
    switchMap( (action) => {
      return this.apollo.mutate({
          mutation: fromGraphql.CREATE_INSTITUTION_SYSTEM_MUTATION,
          variables: {
            input: action?.input
          }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while saving record'),
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(fromActions.upsertSystemNames({systemNames: result?.data}));
                this.notificationService.successMessage('Created Successfully ');
              } else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        )
    })
  ), { dispatch: false})

  getSystemNames$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllInstitutionSystemNamess),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_INSTITUTION_NAMES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action?.filtering
        }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while fetching system names'),
          map(({ data }: any ) => {
            if(data){
              const result: any = Object.values(data)[0]
              result?.response?.status ? this.store.dispatch(loadSystemNamess({systemNamess: result?.data})) : []
            }
          })
        )
    })
  ), { dispatch: false})

  updateSystemNames$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionSystemNamess),
    switchMap( (action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTITUTION_SYSTEM_MUTATION,
        variables: {
          input: action?.input
        }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while saving record'),
          map(({ data }: any) => {
            if (data) {
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(fromActions.upsertSystemNames({systemNames: result?.data}));
                this.notificationService.successMessage('Updated Successfully ');
              } else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        )
    })
  ), { dispatch: false})

  deleteSystemNames$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteInstitutionSystemNamess),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTITUTION_SYSTEM_MUTATION,
        variables: {
          systemUniqueId: action?.systemUniqueId
        }
      })
        .pipe(
          this.notificationService.catchError('Problem occurred while deleting record'),
          map(({data}: any) => {
            if (data){
              const result: any = Object.values(data)[0];
              if (result?.response?.code == '9000') {
                this.store.dispatch(fromActions.deleteSystemNames({ id: action?.id }));
                this.notificationService.successMessage('Deleted Successfully');
              } else {
                this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
              }
            }
          })
        )
    })
  ), { dispatch: false})

  constructor(
    private actions$: Actions,
  private apollo: Apollo,
  private store: Store<AppState>,
  private notificationService: NotificationService,) {
  }
}
